// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__5BBhd","header":"ReportDetails_header__2DOHO","title":"ReportDetails_title__28rSu","left":"ReportDetails_left__3wR2d"};